import { useContext } from "react";
import { NameContext } from "../context/NameContext";

export function usePlaceholder() {
  const { name } = useContext(NameContext);

  return {

    namePlaceholder: name ? `Bist du ${name}?` : "Dein Name",
    nameSinglePlaceholder: name ? `${name}` : "",
    emailPlaceholder: name ? `E-Mail von ${name}` : "Deine E-Mail",
    messagePlaceholder: name
      ? `Was möchtest du uns sagen, ${name}?`
      : "Deine Nachricht oder Wünsche...",

      // Beispiel für Dynamscihe Klaassen 

      nameInputClassName: name? "input-field" : "input-empty"
  };
}

